import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import HeroSection from "./components/HeroSection";
import TrustSection from "./components/TrustSection";
import BenefitsSection from "./components/BenefitsSection";
import TestimonialsSection from "./components/TestimonialsSection";
import Footer from "./components/Footer";
import ProductAdvisor from "./components/ProductAdvisor";
import ProductThinkTank from "./components/ProductThinkTank";
import ProductCommunity from "./components/ProductCommunity";

const LandingPage = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <HeroSection />
      <TrustSection />
      <BenefitsSection />
      <TestimonialsSection />
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/products/advisor" element={<ProductAdvisor />} />
          <Route path="/products/academy" element={<div dangerouslySetInnerHTML={{ __html: '<script>window.location.replace("https://learn.policyarthlabs.com/");</script>' }} />} />
          <Route path="/products/thinktank" element={<ProductThinkTank />} />
          <Route path="/products/community" element={<ProductCommunity />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
